import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Edit_Non_Work.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  Update,
  GetAll,
  GetSingle,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/non_confirming_work/Slice";

import {
  allDepartment,
  allNon_Confirming_Work_Status,
} from "../../../../../../../features/admin/common/Slice";

import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

function Edit_Non_Work({ id, onCancel }) {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm();

  const selectedStatus = watch("non_confirming_work_status_id");

  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);

  const nonworkComplaint = useSelector(
    (state) => state.non_confirming_work.single,
  );

  const nonworkData = Array.isArray(nonworkComplaint)
    ? nonworkComplaint[0]
    : nonworkComplaint;

  const all_department = useSelector((state) => state.common.all_department);
  const all_status = useSelector(
    (state) => state.common.all_non_confirmin_work_status,
  );

  /* ================= FETCH ================= */
  useEffect(() => {
    if (id) dispatch(GetSingle(id));
    dispatch(allDepartment());
    dispatch(allNon_Confirming_Work_Status());
  }, [id, dispatch]);

  /* ================= PREFILL ================= */
  useEffect(() => {
    if (!nonworkData) return;

    setValue("record_no", nonworkData.record_no || "");
    setValue("date_raised", nonworkData.date_raised?.split("T")[0]);
    setValue("department_id", nonworkData.department_id);

    setValue(
      "non_confirming_work_status_id",
      String(nonworkData.non_confirming_work_status_id),
    );

    setValue("non_conformity_statement", nonworkData.non_conformity_statement);
    setValue("clause", nonworkData.clause);
    setValue("initial_action_taken", nonworkData.initial_action_taken);
    setValue("root_cause_analysis", nonworkData.root_cause_analysis);
    setValue(
      "corrective_action_proposed",
      nonworkData.corrective_action_proposed,
    );
    setValue("responsibility", nonworkData.responsibility);
    setValue("target_date", nonworkData.target_date?.split("T")[0]);
    setValue("remark", nonworkData.remark);
  }, [nonworkData, setValue]);

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("record_no", data.record_no);
    formData.append("date_raised", data.date_raised);
    formData.append("department_id", data.department_id);
    formData.append("non_conformity_statement", data.non_conformity_statement);
    formData.append("clause", data.clause);
    formData.append("initial_action_taken", data.initial_action_taken);
    formData.append("root_cause_analysis", data.root_cause_analysis);
    formData.append(
      "corrective_action_proposed",
      data.corrective_action_proposed,
    );
    formData.append("responsibility", data.responsibility);
    formData.append("target_date", data.target_date);
    formData.append("remark", data.remark || "");
    formData.append(
      "non_confirming_work_status_id",
      data.non_confirming_work_status_id,
    );

    // if (data.attach_file instanceof File) {
    //   formData.append("attach_file", data.attach_file);
    // }
    formData.append("attach_file", data.image[0]);

    const res = await dispatch(
      Update({
        id,
        sendData: formData,
      }),
    );

    if (res?.meta?.requestStatus === "fulfilled") {
      setSuccess(true);
      dispatch(GetAll());

      setTimeout(() => {
        onCancel();
      }, 1500);
    }
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* Record No */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Record No.</Form.Label>
                <Form.Control
                  {...register("record_no", {
                    required: "Record No is required",
                  })}
                />
                {errors.record_no && (
                  <Form.Text className="text-danger">
                    {errors.record_no.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Date Raised */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Date Raised</Form.Label>
                <Form.Control
                  type="date"
                  {...register("date_raised", {
                    required: "Date Raised is required",
                    validate: (value) => {
                      const year = value.split("-")[0];

                      if (year.length !== 4) {
                        return "Year must be exactly 4 digits";
                      }

                      const selectedDate = new Date(value);
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);

                      if (selectedDate < today) {
                        return "Past dates are not allowed";
                      }

                      return true;
                    },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.date_raised && (
                  <Form.Text className="text-danger">
                    {errors.date_raised.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Department */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Dept./Area</Form.Label>
                <Controller
                  name="department_id"
                  control={control}
                  rules={{ required: "Department is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_department}
                      value={
                        all_department?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(e) => field.onChange(e?.value)}
                    />
                  )}
                />
                {errors.department_id && (
                  <Form.Text className="text-danger">
                    {errors.department_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Non Conformity */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Non-Conformity Statement</Form.Label>
                <Form.Control
                  {...register("non_conformity_statement", {
                    required: "Statement is required",
                  })}
                />
                {errors.non_conformity_statement && (
                  <Form.Text className="text-danger">
                    {errors.non_conformity_statement.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Clause */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Clause / Document Violated</Form.Label>
                <Form.Control
                  {...register("clause", {
                    required: "Clause is required",
                  })}
                />
                {errors.clause && (
                  <Form.Text className="text-danger">
                    {errors.clause.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Initial Action */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Initial Action Taken</Form.Label>
                <Form.Control
                  {...register("initial_action_taken", {
                    required: "Initial Action is required",
                  })}
                />
                {errors.initial_action_taken && (
                  <Form.Text className="text-danger">
                    {errors.initial_action_taken.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Root Cause */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Root Cause Analysis</Form.Label>
                <Form.Control
                  {...register("root_cause_analysis", {
                    required: "Root Cause is required",
                  })}
                />
                {errors.root_cause_analysis && (
                  <Form.Text className="text-danger">
                    {errors.root_cause_analysis.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Corrective Action */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Corrective Action Proposed</Form.Label>
                <Form.Control
                  {...register("corrective_action_proposed", {
                    required: "Corrective Action is required",
                  })}
                />
                {errors.corrective_action_proposed && (
                  <Form.Text className="text-danger">
                    {errors.corrective_action_proposed.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Responsibility */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Responsibility</Form.Label>
                <Form.Control
                  {...register("responsibility", {
                    required: "Responsibility is required",
                  })}
                />
                {errors.responsibility && (
                  <Form.Text className="text-danger">
                    {errors.responsibility.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Action Taken */}
            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Action Taken</Form.Label>

                <Controller
                  name="non_confirming_work_status_id"
                  control={control}
                  rules={{ required: "Action Taken is required" }}
                  render={({ field }) => (
                    <div className="row">
                      {all_status?.map((status) => (
                        <div className="col-md-4" key={status.value}>
                          <Form.Check
                            type="radio"
                            name={field.name}
                            label={status.label}
                            value={String(status.value)}
                            checked={field.value === String(status.value)}
                            onChange={(e) => field.onChange(e.target.value)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                />

                {errors.non_confirming_work_status_id && (
                  <Form.Text className="text-danger">
                    {errors.non_confirming_work_status_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Remark */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  {...register("remark", {
                    required: "Remark is required",
                  })}
                />
                {errors.remark && (
                  <Form.Text className="text-danger">
                    {errors.remark.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach Document (Optional)</Form.Label>

                <div className="absolute_fields">
                  <Form.Control
                    type="file"
                    {...register("image", {
                      // required:
                      //   typeof getValues("image") === "string"
                      //     ? false
                      //     : "File is required",
                    })}
                    accept="*"
                  />
                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} />
                  </div>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>
                {(() => {
                  const fileValue = watch("image");

                  // URL for preview
                  const fileUrl =
                    typeof fileValue === "string"
                      ? process.env.REACT_APP_IMG_URL + fileValue
                      : fileValue?.length > 0
                      ? URL.createObjectURL(fileValue[0])
                      : null;

                  // Type detection
                  const fileType =
                    typeof fileValue === "string"
                      ? fileValue.toLowerCase()
                      : fileValue?.[0]?.type;

                  if (!fileUrl) return null;

                  return (
                    <div className="image_holder">
                      {/* IMAGE */}
                      {(fileType?.includes("image") ||
                        fileType?.endsWith(".jpg") ||
                        fileType?.endsWith(".jpeg") ||
                        fileType?.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview"
                          style={{ maxWidth: "150px" }}
                        />
                      )}

                      {/* PDF */}
                      {(fileType === "application/pdf" ||
                        fileType?.endsWith(".pdf")) && (
                        <iframe
                          src={fileUrl}
                          style={{ maxWidth: "100px" }}
                          title="PDF"
                        />
                      )}

                      {/* WORD */}
                      {(fileType?.includes("word") ||
                        fileType?.endsWith(".doc") ||
                        fileType?.endsWith(".docx")) && (
                        <div>
                          <p>Word preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType?.includes("spreadsheet") ||
                        fileType?.endsWith(".xlsx") ||
                        fileType?.endsWith(".xls")) && (
                        <div>
                          <p>Excel preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </Form.Group>
            </div>
          </div>
          <div className="row">
            {nonworkData?.Non_Conformig_Files?.length > 0 &&
              nonworkData?.Non_Conformig_Files?.map((file, i) => {
                const fileUrl = process.env.REACT_APP_IMG_URL + file?.file;
                const fileType = file?.file?.toLowerCase() || "";

                return (
                  <div className="col-md-3 mb-3" key={i}>
                    <div className="image_holder">
                      <div>{file?.Non_Confirming_Work_Status?.name}</div>

                      {/* IMAGE */}
                      {(fileType.includes("image") ||
                        fileType.endsWith(".jpg") ||
                        fileType.endsWith(".jpeg") ||
                        fileType.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview img-fluid"
                          style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* PDF */}
                      {fileType.endsWith(".pdf") && (
                        <iframe
                          src={fileUrl}
                          title="PDF Preview"
                          style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* WORD */}
                      {(fileType.endsWith(".doc") ||
                        fileType.endsWith(".docx")) && (
                        <div>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            📄 Open Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType.endsWith(".xls") ||
                        fileType.endsWith(".xlsx")) && (
                        <div>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            📊 Open Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>

          {/* Buttons */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Saved Successfully!" />
            ) : (
              <>
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={onCancel}
                >
                  Reset
                </Button>
                <Button type="submit" className="permission_btn Yes_btn">
                  Save
                </Button>
              </>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}

export default Edit_Non_Work;
